// components/grid/ExpandAllButton.jsx
//
// The quiet "Expand all" / "Collapse all" link above a grid whose rows open
// into a detail (master-detail), or into a group. One click opens every
// loaded row; the label then offers to close them all. A page wires it in
// two places:
//
//   const expandAll = useExpandAllRows();   // hooks/useExpandAllRows.js
//   <ExpandAllButton {...expandAll} />
//   <AgGridReact {...expandAll.gridProps} … />

import { useTranslation } from 'react-i18next';
import { CaretDoubleDown, CaretDoubleUp, ICON } from '../../icons';
import './ExpandAllButton.css';

export default function ExpandAllButton({ enabled, allExpanded, toggle }) {
  const { t } = useTranslation();
  const Icon = allExpanded ? CaretDoubleUp : CaretDoubleDown;
  return (
    <div className="expand-all-row">
      <button type="button" className="expand-all-btn" onClick={toggle} disabled={!enabled}>
        <Icon size={ICON.md} aria-hidden="true" />
        <span>{allExpanded ? t('grid.collapseAll') : t('grid.expandAll')}</span>
      </button>
    </div>
  );
}
